<template>
  <div class="select-3 flex-v-center">
    <div class="content">
      <div class="title">
        <p>海量资源 数据透明化</p>
        <p>服务上千+媒体，覆盖6亿+用户</p>
      </div>
      <div class="select-cards flex-h-center">
        <div class="cards-item flex-center">
          <img src="../images/select-3-1.png" alt />
        </div>
        <div class="cards-item flex-center">
          <img src="../images/select-3-2.png" alt />
        </div>
        <div class="cards-item flex-center">
          <img src="../images/select-3-3.png" alt />
        </div>
        <div class="cards-item flex-center">
          <img src="../images/select-3-4.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "selectThree"
  };
</script>

<style lang="scss" scoped>
  @import "~@/styles/index.scss";

  .select-3 {
    width: 100%;
    min-width: 960px;
    box-sizing: border-box;
    text-align: center;
    background: RGBA(0, 27, 105, 1);

    .content {
      width: 1200px;
      text-align: center;
      .title {
        margin-top: 36px;

        p:nth-child(1) {
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 15px;
        }

        p:nth-child(2) {
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 45px;
        }
      }

      .select-cards {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .cards-item {
          width: 562px;
          height: 263px;
          font-family: PingFangSC-Medium, PingFang SC;
          box-sizing: border-box;
           margin-bottom: 35px;
           margin-right: 35px;
           &:nth-child(2n+2){
             margin-right: 0px;
           }

          img {
            width: 100%;
          }

          }
        }

        .cards-item:nth-child(4) {
          margin-right: 0;
        }

        .cards-item:hover {
          background: rgba(117, 148, 178, 1);
          box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.13);
          transition: all .6s;
          transform: scale(1.1);

          .item-title {
            color: #FFFFFF;
          }

          .item-content {
            color: #D3D3D3;
          }
        }
      }
  }
</style>